import { images } from './images';

export interface HeroSlide {
  title: string;
  subtitle: string;
  cta: { label: string; to: string };
  image: string;
  alt: string;
}

export const heroSlides: HeroSlide[] = [
  {
    title: 'Speak English with confidence',
    subtitle: 'Real conversations from your very first lesson, with qualified teachers',
    cta: { label: 'Book a free lesson', to: '#enquire' },
    image: images.hero,
    alt: 'Adult students laughing and talking around a table in a school lounge',
  },
  {
    title: 'Your classroom is the city',
    subtitle: 'Year-round campuses in London, Dubai, New York and more — start any Monday',
    cta: { label: 'Explore destinations', to: '/destinations' },
    image: images.london,
    alt: 'A street in central London on a bright day',
  },
  {
    title: 'Summers they talk about for years',
    subtitle: 'Safe, fully planned English camps for teens and children',
    cta: { label: 'See summer programmes', to: '/destinations#seasonal' },
    image: images.young,
    alt: 'Teenage students working together in a bright classroom',
  },
  {
    title: 'English that works at work',
    subtitle: 'Business English and professional qualifications taught in English',
    cta: { label: 'View all programmes', to: '/programmes' },
    image: images.teacher,
    alt: 'A teacher leading a small group lesson',
  },
  {
    title: 'A home close to class',
    subtitle: 'Serviced student rooms and studios near your campus, arranged for you',
    cta: { label: 'See student life', to: '/about/media' },
    image: images.accommodation,
    alt: 'A bright, modern student bedroom',
  },
];
